var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{class:[_vm.status === 'clear' ? _vm.$style.clear : _vm.status === 'fault' ? _vm.$style.fault : '', _vm.$style.pulse],attrs:{"r":_vm.radius}})}
var staticRenderFns = []

export { render, staticRenderFns }